import { Map } from "ol";
import { CustomMapEventTypes } from "../types/map";
import { findFeatureById } from "./findFeatureById";
import { findLayerByFeatureId } from "./findLayerByFeatureId";
import { focusAnimation } from "./focusAnimation";

export const zoomOnFeature = (
  map: Map,
  featureId: string,
  maxZoom = 20,
): boolean => {
  const focusFeature = findFeatureById(map, featureId);

  // If layer is not visible, set it to visible
  const layer = findLayerByFeatureId(map, focusFeature?.getId()?.toString());

  if (!layer?.getVisible()) {
    layer?.setVisible(true);
    map.dispatchEvent(CustomMapEventTypes.SettingsChanged);
  }
  const extent = focusFeature?.getGeometry()?.getExtent();
  if (!extent?.length) return false;
  map.getView().fit(extent);
  const curZoom = map.getView().getZoom();
  if (curZoom && curZoom > maxZoom) {
    map.getView().setZoom(maxZoom);
    // Animate the feature a bit
    if (layer && focusFeature) {
      focusAnimation(layer, focusFeature, map);
    }
    return true;
  }
  return false;
};
